import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayeeRow } from "@wingspanhq/wingspan-api-sdk";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";
import { WorkLogPayerStatusCell } from "../WorkLogPayerStatusCell";
import { TableItemData } from "./TableWorkLogsPayerView";

type ColumnsConfig = {
  payeesMap: Map<string, PayeeRow>;
};

export const getColumns = ({
  payeesMap
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: {
        text: "Contractor"
      }
    },
    renderFunction: item => {
      // TODO(v3): payee lookup keyed on `payeeEngagementId` (v1 used `payeeId`).
      const payee = payeesMap.get(item.data.payeeEngagementId ?? "");
      if (!payee) {
        return <WSTableCell text="-" />;
      }
      return (
        <WSTableCell
          text={selectorSearchRowName(payee)}
          secondaryText={payee.email ?? undefined}
          truncationOptions={{
            text: { allowTwoLines: true }
          }}
        />
      );
    }
  },
  {
    config: {
      header: {
        text: "Work log #"
      }
    },
    renderFunction: item => <WSTableCell text={item.data.workLogNumber} />
  },
  {
    config: {
      header: {
        text: "Amount"
      }
    },
    renderFunction: item => (
      <WSTableCell text={formatMoney(item.data.totalAmount ?? 0, "USD")} />
    )
  },
  {
    config: {
      header: {
        text: "Last modified"
      }
    },
    // TODO(v3): v3 WorkLog has no `updatedAt`; approximate "Last modified" with
    // the in-review event timestamp.
    renderFunction: item => (
      <WSTableCell
        text={toWSDateString(item.data.events?.inReviewAt, "timeframe")}
      />
    )
  },
  {
    config: {
      header: {
        text: "Status"
      }
    },
    renderFunction: item => <WorkLogPayerStatusCell workLog={item.data} />
  }
];
